import { render, staticRenderFns } from "./IndicatorBooksTable.vue?vue&type=template&id=ca77c76e&scoped=true&"
import script from "./IndicatorBooksTable.vue?vue&type=script&lang=js&"
export * from "./IndicatorBooksTable.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorBooksTable.vue?vue&type=style&index=0&id=ca77c76e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca77c76e",
  null
  
)

export default component.exports